import {
  Component,
  computed,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modal, ResolvableModal, TranslatePipe } from '@softline/ui-core';
import { DynamicModule } from '@softline/dynamic';
import { UserInfoService } from '@softline/auth';
import { SoftAppsUserInfo } from '@softapps/core';

@Component({
  selector: 'softline-change-baustelle',
  imports: [CommonModule, DynamicModule, TranslatePipe],
  templateUrl: './change-baustelle.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./change-baustelle.dialog.css'],
})
export class ChangeBaustelleDialog extends ResolvableModal<any> implements OnInit {
  private readonly userInfo = inject<UserInfoService<SoftAppsUserInfo>>(UserInfoService);

  lieferadresse!: any;

  readonly ktostammnummer = computed(() => this.userInfo.value()?.ktostammnummer);

  ngOnInit(): void {}

  onSubmit(baustelle: any): void {
    this.resolve(baustelle);
  }
}
